module.exports = "<div class=\"app-badge\"> <div class=\"badge\" ng-style=\"{background: $ctrl.color}\"> <md-icon ng-if=\"$ctrl.icon\">{{$ctrl.icon}}</md-icon> <span>{{$ctrl.translation}}</span> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/appBadges/appBadge.html
// module id = 1269
// module chunks = 28